import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-background pt-16 md:pt-24 lg:pt-32 pb-16" data-id="element-62">
      <div className="container max-w-screen-2xl relative z-10" data-id="element-63">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center" data-id="element-64">
          <div className="flex flex-col justify-center space-y-8" data-id="element-65">
            <div className="space-y-4" data-id="element-66">
              <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none text-foreground" data-id="element-67">
                Transform Your Property with{' '}
                <span className="text-primary" data-id="element-68">Expert Care</span>
              </h1>
              <p className="max-w-[600px] text-muted-foreground md:text-xl leading-relaxed" data-id="element-69">
                Reliable, high-quality landscaping and snow plowing services for
                residential and commercial properties in Lancaster, NY and
                surrounding suburbs.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-70">
              <a href="#quote" className="inline-flex h-12 items-center justify-center rounded-md bg-primary px-8 text-base font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90" data-id="element-71">
                Get a Free Quote
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-72" />
              </a>
              <a href="tel:+15555555555" className="inline-flex h-12 items-center justify-center rounded-md border border-input bg-background px-8 text-base font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground" data-id="element-73">
                Call Us Today
              </a>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 text-sm text-muted-foreground" data-id="element-74">
              <div className="flex items-center gap-2" data-id="element-75">
                <CheckCircle2 className="h-5 w-5 text-primary" data-id="element-76" />
                <span data-id="element-77">Year-round property care</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-78">
                <CheckCircle2 className="h-5 w-5 text-primary" data-id="element-79" />
                <span data-id="element-80">Locally owned & operated</span>
              </div>
            </div>
          </div>
          <div className="relative mx-auto w-full max-w-[500px] lg:max-w-none" data-id="element-81">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl shadow-2xl" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/hiWQHXmbyDgfvSmZkpQFY1/hauser1.jpg" alt="Beautifully landscaped front yard" className="object-cover w-full h-full" data-id="element-83" />
            </div>
            <div className="absolute -bottom-6 -left-6 h-48 w-48 rounded-2xl border-8 border-background overflow-hidden shadow-xl hidden md:block" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/pNknGe1tw3jfqrQWUbzArG/hauser4.webp" alt="Lawn maintenance" className="object-cover w-full h-full" data-id="element-85" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}